<template >
  <v-app>
    <div>
      <!-- <h3>User</h3> -->
      <v-btn
        color="primary"
        style="float:right;padding-left:20px;"
        @click="addUser('new',0)"
      >{{$t('Add')}}</v-btn>
      <v-select
        v-model="selectedStall"
        :items="stallNameList"
        :label="$t('Stall') + ': '"
        required
        @input="onSelectStall"
      ></v-select>
    </div>

    <div style="text-align: center;">
      <h3
        v-if="errorList != ''"
        style="font-size:14px;"
        class="txtClrRed"
      >{{$t('Error')}}: {{errorList}}</h3>
    </div>

    <!-- table -->
    <!-- <div v-if="stallInfo.length==0">
      <br />
      <h3 style="font-size:25px;color:#1976d2;">No stalls found, add a stall?</h3>
    </div>-->
    <v-card>
      <table class="tableList">
        <thead>
          <tr>
            <th class="text-left">{{$t('Name')}}</th>
            <th class="text-left">{{$t('Active')}}</th>
            <th class="text-left">{{$t('Stall')}}</th>
            <th class="text-left">{{$t('Edit')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user,i) in userInfoList" :key="user.name">
            <td>{{ user.ez }}</td>
            <td>
              <v-checkbox
                v-model="user.lc"
                style="color:black;margin: 0px;"
                color="primary"
                readonly
              ></v-checkbox>
            </td>
            <td>{{ user.qz }} - {{ user.ra }}</td>
            <td style="padding:0px;">
              <v-icon @click="addUser('edit',i)">edit</v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card>

    <!-- Dialog -->
    <v-layout class="text-xs-center">
      <v-dialog
        id="addUserDlg"
        v-model="addUserDialog"
        persistent
        width="550"
        style="margin:0px !important;"
      >
        <v-card>
          <v-card-title
            class="headline lighten-2"
            style="padding-top: 0px; padding-bottom: 0px;background-color:#1976d2;color:white;"
          >
            <span v-if="newOrEdit == 'new'">{{$t('NewUser')}}</span>
            <span v-if="newOrEdit == 'edit'">{{$t('EditUser')}}</span>
          </v-card-title>
          <v-card-text style="padding:5px;padding-bottom:0px;">
            <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
              <v-layout wrap>
                <!-- //Name -->
                <v-flex xs4>
                  <h5 class="userProfileTxt">{{$t('Name')}} :</h5>
                </v-flex>
                <v-flex xs8>
                  <input
                    v-model="userName"
                    class="form-control"
                    required
                    autocomplete="nope"
                    type="text"
                    name="userName"
                    @input="userName = $event.target.value"
                  />
                </v-flex>

                <!-- //Stall -->
                <v-flex v-if="!((newOrEdit == 'edit') && ktnIDEquZero)" xs4>
                  <h5 class="userProfileTxt">{{$t('Stall')}}:</h5>
                </v-flex>
                <v-flex v-if="!((newOrEdit == 'edit') && ktnIDEquZero)" xs8>
                  <v-select
                    v-model="selectedUserStall"
                    style="padding:0px;max-height:40px;"
                    class="stallInput"
                    :items="stallNameListNoAllSlt"
                    required
                    outline
                    @input="onSelectUserStall"
                  ></v-select>
                </v-flex>

                <!-- //Password -->
                <v-flex xs4>
                  <h5 style="margin-top:4px;" class="userProfileTxt">{{$t('Password')}}:</h5>
                </v-flex>
                <v-flex xs8>
                  <input
                    v-model="userPwd"
                    class="form-control"
                    style="margin-top:4px;"
                    required
                    autocomplete="nope"
                    type="password"
                    name="userPwd"
                    @input="userPwd = $event.target.value"
                  />
                </v-flex>

                <!-- //Confirm Password -->
                <v-flex xs4>
                  <h5 style="margin-top:4px;" class="userProfileTxt">{{$t('ConfirmPassword')}}:</h5>
                </v-flex>
                <v-flex xs8>
                  <input
                    v-model="userCfmPwd"
                    class="form-control"
                    style="margin-top:4px;"
                    required
                    autocomplete="nope"
                    type="password"
                    name="userCfmPwd"
                    @input="userCfmPwd = $event.target.value"
                  />
                </v-flex>

                <!-- //CheckBox Active -->
                <v-flex xs12>
                  <v-checkbox
                    v-model="cUActive"
                    style="color:black;margin-top:0px;"
                    color="primary"
                    :label="$t('Active')"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <span
              v-if="errorUserDataWithTran != ''"
              style="padding:16px;font-size:14px;"
              class="txtClrRed"
            >{{''+$t(errorUserDataWithTran)+''}}</span>
            <span
              v-if="errorUserData != ''"
              style="padding:16px;font-size:14px;"
              class="txtClrRed"
            >{{errorUserData}}</span>
          </v-card-text>
          <v-card-actions style="padding:0px;">
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="addUserDialog = false">{{$t('Cancel')}}</v-btn>
            <v-btn color="primary" flat @click="saveUserInfo()">{{$t('Save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import { translateErrorMsg } from './translateErrorMsg'
import JS from './JsonService'
import VersionDialog from '../src/VersionNotMatchDialog'
export default {
  components: {
    VersionDialog
  },
  mixins: [translateErrorMsg],
  data() {
    return {
      selectedStall: 'All',
      selectedStallID: 0,
      selectedUserStallID: 0,
      stallInfo: [],
      stallNameList: [],
      stallNameListNoAllSlt: [],
      errorList: '',
      addUserDialog: false,
      userInfoList: [],
      newOrEdit: '',
      userName: '',
      userLv: 0,
      cUActive: true,
      userPwd: '',
      userCfmPwd: '',
      selectedUserStall: '',
      userId: 0,
      errorUserData: '',
      errorUserDataWithTran: '',
      found: false,
      foundID: 0,
      ktnIDEquZero: false,
      versionError: false
    }
  },
  created: function() {
    const fillterStall = sessionStorage.getItem('sltFilterStallName')
    if (
      fillterStall == '' ||
      fillterStall == null ||
      fillterStall == undefined
    ) {
      this.selectedStall = 'All'
    } else {
      this.selectedStall = fillterStall
    }

    let mchCode = sessionStorage.getItem('backendMchCode')
    //console.log(mchCode)

    this.versionError = false
    var version = sessionStorage.getItem('version')
    const url = 'Back/GetKtnList'
    const parameter = {
      av: version,
      kp: mchCode
    }

    JS.request(url, parameter)
      .then(response => {
        console.log(response.data)
        if (
          response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
          response.data == 'Version Not Match'
        ) {
          this.versionError = true
        } else {
          this.versionError = false
          if (response.data.ListOfKtn) {
            this.errorList = ''
            this.stallInfo = response.data.ListOfKtn
            this.stallNameList = ['All']
            this.stallNameListNoAllSlt = []
            for (let i = 0; i < response.data.ListOfKtn.length; i++) {
              this.stallNameList.push(
                response.data.ListOfKtn[i].qz +
                  ' - ' +
                  response.data.ListOfKtn[i].ra
              )
              this.stallNameListNoAllSlt.push(
                response.data.ListOfKtn[i].qz +
                  ' - ' +
                  response.data.ListOfKtn[i].ra
              )
            }
            console.log(this.stallNameListNoAllSlt)
            this.getUserList()
          } else {
            this.errorList = response.data
          }
        }
      })
      .catch(error => {
        //console.log(error)
        this.errorList = error
        this.versionError = false
      })
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    onSelectStall(event) {
      this.selectedStall = event
      console.log(this.selectedStall)
      sessionStorage.setItem('sltFilterStallName', this.selectedStall)
      this.getUserList()
    },
    getUserList() {
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)

      if (this.selectedStall == 'All') {
        this.selectedStallID = 0
      } else {
        console.log(this.stallInfo.length)
        for (let i = 0; i < this.stallInfo.length; i++) {
          if (
            this.selectedStall ==
            this.stallInfo[i].qz + ' - ' + this.stallInfo[i].ra
          ) {
            this.selectedStallID = this.stallInfo[i].rd
            break
          }
        }
      }

      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetUserList'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: this.selectedStallID
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfUser) {
              this.errorList = ''
              this.userInfoList = response.data.ListOfUser
            } else {
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.errorList = error
          this.versionError = false
        })
    },
    addUser(mode, index) {
      this.errorUserData = ''
      this.errorUserDataWithTran = ''
      console.log(index)
      console.log(this.userInfoList)
      this.addUserDialog = true
      this.newOrEdit = mode
      if (this.newOrEdit == 'edit') {
        this.userId = this.userInfoList[index].m
        this.userName = this.userInfoList[index].ez
        this.userLv = this.userInfoList[index].aq
        this.cUActive = this.userInfoList[index].lc
        this.userPwd = ''
        this.userCfmPwd = ''
        this.selectedUserStall =
          this.userInfoList[index].qz + ' - ' + this.userInfoList[index].ra
        if (this.userInfoList[index].rd != 0) {
          this.ktnIDEquZero = false
        } else {
          this.ktnIDEquZero = true
        }
      } else {
        this.userId = 0
        this.userName = ''
        this.userLv = 0
        this.cUActive = true
        this.userPwd = ''
        this.userCfmPwd = ''
        this.selectedUserStall = ''
      }
    },
    onSelectUserStall(event) {
      this.selectedUserStall = event
      console.log(this.selectedUserStall)
    },
    saveUserInfo() {
      this.errorUserDataWithTran = ''
      this.errorUserData = ''
      if (this.newOrEdit == 'new') {
        if (this.userName.trim() == '' || this.userName.trim() == undefined) {
          this.errorUserDataWithTran = translateErrorMsg.translateMsg(
            'User Name Cannot be empty'
          )
        } else if (
          this.selectedUserStall == '' ||
          this.selectedUserStall == undefined
        ) {
          this.errorUserDataWithTran = translateErrorMsg.translateMsg(
            'Stall Not Found, Please Select a Stall'
          )
        } else if (
          this.userPwd.trim() == '' ||
          this.userPwd.trim() == undefined
        ) {
          this.errorUserDataWithTran = translateErrorMsg.translateMsg(
            'User Password cannot be empty'
          )
        } else {
          if (this.userCfmPwd.trim() != this.userPwd) {
            this.errorUserDataWithTran = translateErrorMsg.translateMsg(
              'User Password does not match Confirm Password'
            )
          } else {
            this.saveUserInfoToServer()
          }
        }
      } else {
        if (this.userName.trim() == '' || this.userName.trim() == undefined) {
          this.errorUserDataWithTran = translateErrorMsg.translateMsg(
            'User Name Cannot be empty'
          )
        } else {
          if (this.userCfmPwd.trim() != this.userPwd.trim()) {
            this.errorUserDataWithTran = translateErrorMsg.translateMsg(
              'User Password does not match Confirm Password'
            )
          } else {
            this.saveUserInfoToServer()
          }
        }
      }
    },
    saveUserInfoToServer() {
      let mchCode = sessionStorage.getItem('backendMchCode')

      console.log(this.stallInfo)
      for (let i = 0; i < this.stallInfo.length; i++) {
        if (
          this.selectedUserStall ==
          this.stallInfo[i].qz + ' - ' + this.stallInfo[i].ra
        ) {
          this.selectedUserStallID = this.stallInfo[i].rd
          break
        } else {
          this.selectedUserStallID = 0
        }
      }

      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Back/AddEditUser'
      const parameter = {
        av: version,
        kp: mchCode,
        m: this.userId,
        ez: this.userName,
        aq: this.userLv,
        on: this.userPwd.trim(),
        lc: this.cUActive,
        rd: this.selectedUserStallID
      }
      console.log(parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data[0].m) {
              this.errorUserData = ''

              this.found = false
              this.foundID = 0
              for (let i = 0; i < this.userInfoList.length; i++) {
                if (this.userInfoList[i].m == response.data[0].m) {
                  this.found = true
                  this.foundID = i
                  break
                }
              }
              console.log(this.found)
              console.log(this.foundID)
              if (this.found) {
                this.userInfoList[this.foundID].ez = response.data[0].ez
                this.userInfoList[this.foundID].aq = response.data[0].aq
                this.userInfoList[this.foundID].lc = response.data[0].lc
                this.userInfoList[this.foundID].rd = response.data[0].rd
                this.userInfoList[this.foundID].qz = response.data[0].qz
                this.userInfoList[this.foundID].ra = response.data[0].ra
              } else {
                const newuserInfoList = []
                newuserInfoList.m = response.data[0].m
                newuserInfoList.ez = response.data[0].ez
                newuserInfoList.aq = response.data[0].aq
                newuserInfoList.lc = response.data[0].lc
                newuserInfoList.rd = response.data[0].rd
                newuserInfoList.qz = response.data[0].qz
                newuserInfoList.ra = response.data[0].ra
                this.userInfoList.push(newuserInfoList)
              }

              this.addUserDialog = false
            } else {
              this.errorUserData = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.errorUserData = error
          this.versionError = false
        })
    }
  }
}
</script>

<style>
.v-dialog {
  overflow-x: hidden !important;
  border-radius: 5px !important;
}
.v-select__selections {
  padding-top: 0px !important;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 20px !important;
  border: 1px solid #ced4da !important;
}
.v-text-field--outline > .v-input__control {
  height: 55px;
}
</style>
